export default "__VITE_ASSET__a3KLDQsV__"